export default "__VITE_ASSET__449e2079__"